import React from "react";
//#region types
import { ExportItemTypeProps } from "models/propTypes/revisorPropTypes";
//#endregion
//#region components
import { Grid, Skeleton } from "@mui/material";
import ExportItem from "./exportItem";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const ExportItemType: React.FC<ExportItemTypeProps> = (props) => {
  return (
    <Grid item container direction={"column"} rowGap={1} className={cssExports.exportItemType}>
      <Grid item container columnGap={2}>
        <Grid item xs className={cssExports.exportItemTypeTitle}>
          {props.title}
        </Grid>
        <Grid
          item
          xs="auto"
          className={clsx(
            cssExports.exportItemTypeStatus,
            props.isDownloadAvailable ? cssExports.exportDownloaded : cssExports.exportQueued
          )}
        >
          {props.statusLabelText}
        </Grid>
      </Grid>
      <Grid item container direction="column">
        {props.displayLoading ? (
          <Grid item container spacing={1} direction={"column"}>
            {Array.from({ length: 3 }).map((_, index) => (
              <Grid item>
                <Skeleton key={index} variant="rectangular" width={150} height={12} />
              </Grid>
            ))}
          </Grid>
        ) : props.exportItems.length > 0 ? (
          props.exportItems.map((item, index) => <ExportItem key={index} {...item} />)
        ) : (
          props.emptyListPlaceholder
        )}
      </Grid>
    </Grid>
  );
};

export default ExportItemType;
